import { map as rxjsmap } from 'rxjs';



import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

import { Category } from '../models/';
import { BaseServices } from './../../kuba.services';
import { HttpClient, HttpHeaderResponse } from '@angular/common/http';

@Injectable()
export class BusinessCategoryService {
    constructor(private http: HttpClient) { }

    getAllCategories() {
        return this.http
            .get(
                environment.BASE_URL + '/business/categories',

            ).pipe(rxjsmap(result => result));
    }
    getAllBusiness() {
        // Use pagination with large page size to get all businesses
        const filter = {
            PageNumber: 1,
            PageSize: 10000, // Large number to get all businesses
            SortColumn: 'CompanyName',
            SortDirection: 'ASC'
        };

        return this.http
            .post<any>(environment.BASE_URL + '/businesses/paged', filter)
            .pipe(
                map((result: any) => result.Items || [])
            );
    }

    create(newCategory: Category) {
        return this.http
            .post<HttpHeaderResponse>(
                environment.BASE_URL + '/business/category',
                newCategory,

            ).pipe(rxjsmap((response: HttpHeaderResponse) => {
                return response;
            }));
    }

    update(id: number, ExistingCategory: Category) {
        return this.http
            .put<HttpHeaderResponse>(
                environment.BASE_URL + '/business/category/' + id,
                ExistingCategory,

            ).pipe(rxjsmap((response: HttpHeaderResponse) => {
                return response;
            }));
    }

    deleteCategory(id: number) {
        return this.http
            .delete<HttpHeaderResponse>(environment.BASE_URL + '/business/category/' + id, ).pipe(rxjsmap((response: HttpHeaderResponse) => {
                return response;
            }));
    }
}
